module.exports = fox._r("images/comments.gif", __webpack_public_path__ + "images/comments.gif");


//////////////////
// WEBPACK FOOTER
// ./images/comments.gif
// module id = 1036
// module chunks = 4